import Vue from 'vue'
import cfg from './config.json'

const Config = {
	install(Vue) {
		Vue.prototype.$cfg = function(path) {
			let keys = path.split('.')
			let value = cfg

			try {
				keys.forEach(key => {
					value = value[key]
				})
			} catch (e) {
				value = undefined
			}

			return value ?? path
		}
	}
}

Vue.use(Config)
